import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { sassOptOut } from '../utils/sassOptOut';
import StoreLayout from './components/store/StoreLayout';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout } from './components/layout/DefaultLayout';

sassOptOut('forms');

const shopId = window?.Jbhifi?.shopId;
const container = document.getElementById('store-page-app');

if (container) {
  const root = createRoot(container);
  root.render(
    <BaseContentProvider>
      <DefaultLayout>
        <StoreLayout shopId={shopId} />
      </DefaultLayout>
    </BaseContentProvider>
  );
}
